import { createFileRoute } from '@tanstack/react-router';
import { Eye } from 'lucide-react';
import { ComingSoon } from '@/components/layout/ComingSoon';

export const Route = createFileRoute('/_app/lancamentos/transparencia')({
  component: TransparenciaPage,
});

function TransparenciaPage() {
  return (
    <ComingSoon
      eyebrow="Lançamento · Anual"
      title="Transparência"
      description="Checklist dos 24 itens obrigatórios do portal de transparência."
      icon={Eye}
      bullets={[
        'Acompanhamento dos 24 checkboxes do portal Suzano',
        'Anexo de documentos comprobatórios',
        'Trilha de revisão e validação',
      ]}
      etaLabel="próxima fase"
    />
  );
}
